import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-list.css';
import { EGDSListItem } from '../list-item/index.esm.js';
import { EGDSListOrientations, EGDSListSizes, EGDSListTypes } from '../types/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSListContext = React.createContext({});
const EGDSList = props => {
  const {
    bullet,
    children,
    className,
    data,
    orientation,
    size,
    type,
    spacing,
    indent,
    ...attributes
  } = props;
  const baseClass = 'uitk-typelist'; // Temporary: name clash with menu
  const cssClassNames = getClassNameList(baseClass, orientation && `${baseClass}-${EGDSListOrientations.get(orientation)}`, size && `${baseClass}-${EGDSListSizes.get(size)}`, spacing && `${baseClass}-spacing`, className);
  // Renders the custom Tag
  const Tag = type && EGDSListTypes.get(type) || 'ul';
  // Renders children if data is used
  const dataGuard = dataType => dataType[0].content !== undefined;
  const newChildren = [];
  const EGDSListContextValue = React.useMemo(() => ({
    bullet,
    orientation,
    type,
    size,
    indent
  }), [bullet, orientation, type, size, indent]);
  data?.forEach((item, index) => {
    newChildren.push(jsx(EGDSListItem, {
      children: dataGuard(data) ? [item && item?.icon, item?.content] : item
    }, `listitem-${index}`));
  });
  return jsx(Tag, {
    className: cssClassNames,
    ...attributes,
    children: jsx(EGDSListContext.Provider, {
      value: EGDSListContextValue,
      children: !data && children || newChildren || null
    })
  });
};
EGDSList.displayName = 'EGDSList';
EGDSList.defaultProps = {
  bullet: 'default',
  orientation: 'stacked',
  size: 2,
  type: 'unordered',
  spacing: true,
  indent: true
};
export { EGDSList, EGDSListContext as default };